
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component<InfoBanner>({})
export default class InfoBanner extends Vue {
	@Prop({ type: String, required: true }) private text!: string;
	@Prop({ type: String, required: false, default: 'primary' }) private color!: string;
	@Prop({ type: String, required: false, default: 'mdi-information-outline' }) private icon!: string;
	@Prop({ type: String, required: false, default: 'label-sm' }) private textClass!: string;
}
